import { getFocusStyle, IStyle, memoizeFunction } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/style-utilities';
import { IAppTheme, useAppTheme } from 'common';

interface IArtifactViewStyles {
  root: IStyle;
  contentContainer: IStyle;
  errorContentContainer: IStyle;
  textOrIcon: IStyle;
  image: IStyle;
}

const getStyles = memoizeFunction((theme: IAppTheme, hasError: boolean, size: number, zoomOnFocus: boolean) => {
  return mergeStyleSets({
    root: {
      boxSizing: 'border-box',
      border: `2px solid ${theme.appColors?.white100ToAnchor20}`,
      borderRadius: '50%',
      ...getFocusStyle(theme, {
        borderColor: theme.semanticColors.buttonText,
        width: 2,
        inset: hasError ? 0 : -1,
        borderRadius: '50%',
        outlineColor: 'transparent',
      }),
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow: 'none !important',
        outline: 'none !important',
      },
      '&:focus': zoomOnFocus
        ? {
            transform: 'scale(1.1)',
            boxShadow: 'none !important',
            outline: 'none !important',
          }
        : {},
    },
    contentContainer: {
      width: '100%',
      borderRadius: '50%',
    },
    errorContentContainer: {
      border: '2px solid transparent',
      backgroundImage: `linear-gradient(${theme.palette.white}, ${theme.palette.white}), ${theme.appColors?.redGradient}`,
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    },
    textOrIcon: {
      background: theme.appColors?.gray94ToAnchor10,
      width: size,
      height: size,
      borderRadius: '50%',
      boxSizing: 'border-box',
    },
    image: {
      borderRadius: '50%',
    },
  } as IArtifactViewStyles);
});

export const useArtifactViewStyles = (hasError: boolean, size: number, zoomOnFocus: boolean) => {
  const theme = useAppTheme();
  return getStyles(theme, hasError, size, zoomOnFocus);
};
